import * as $ from "jquery";
import * as ko from "knockout";
import * as _ from "lodash";

import { Application } from "../application";
import { Command } from "../command";
import { CommandType } from "../commandType";
import { ActivePanel } from "../state/activePanel";
import {Bookmark} from "../state/bookmark";
import {SidebarItemType} from "../state/sidebarItemType";

export class RemoveBookmarkCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.RemoveBookmark;

    canExecute = ko.computed(() => {
        let estimate = this.app.state.estimate();
        let costbook = this.app.state.costbook();

        return !(!estimate || !costbook);
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(rowIndex?: number): JQueryPromise<any> {
        let dfd = $.Deferred();
        
        if(!rowIndex)
            dfd.reject();

        if (!this.canExecute())
            return dfd.reject().promise();

        let estimate = this.app.state.estimate();
        let costbook = this.app.state.costbook();

        if (!estimate || !costbook)
            return dfd.reject().promise();
        
        this.app.apiManager.bookmarks.deleteBookmark({
            index: rowIndex!,
            estimateId: estimate.id(),
            costbookId: costbook.id
        }).then(() => {

            let bookmark = _.find(this.app.state.bookmarks(), (b:Bookmark) => {
                return b.index == rowIndex;
            });

            console.log("remove-bookmark-command, bookmark to remove", bookmark);
            
            if(bookmark)
                this.app.state.bookmarks.remove(bookmark);

            this.app.state.activeSidebarItem(undefined);
            this.app.state.activeSidebarItem(SidebarItemType.Bookmarks);
            
            dfd.resolve();
        });

        return dfd.promise();
    }

    name = "Remove bookmark";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/removeBookmarkCommand.ts